import { Component, ElementRef, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { AirModel } from 'src/app/models/air/air-model';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';

export interface ReservationData {
  selectedProduct: MarketAirProductsModel | null;
  marketProductsDefId: number | null;
  productId: number | null;
  uuid: string | null;
}

const weekDaysMap: { [key: number]: string } = {
  1: "Pts",
  2: "Sal",
  3: "Çar",
  4: "Per",
  5: "Cum",
  6: "Cmt",
  7: "Paz"
};


@Component({
  selector: 'app-air-card',
  templateUrl: './air-card.component.html',
  styleUrls: ['./air-card.component.scss'],
})


export class AirCardComponent {

  @ViewChildren('details') detailsElements: QueryList<ElementRef>;

  @Input() model: AirModel = null;
  @Input() loading: boolean = false;
  @Output() makeReservation: EventEmitter<ReservationData> = new EventEmitter<ReservationData>();
  @Output() priceInfo: EventEmitter<MarketAirProductsModel> = new EventEmitter<MarketAirProductsModel>();
  @Output() frontTariffNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() endTariffNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() frontEndTariffNotFound: EventEmitter<any> = new EventEmitter<any>();




  constructor(public translation: TranslateService, private languageService: ChangeLanguageService,
    private searchLogHistoryService: SearchLogClickHistoryService
  ) {

  }

  _makeReservation(selectedProduct: MarketAirProductsModel = null, marketProductsDefId = null, productId = null, uuid = null) {
    this.makeReservation.emit({selectedProduct,marketProductsDefId,productId, uuid})
  }
  _priceInfo(product: MarketAirProductsModel) {
    this.priceInfo.emit(product)
    this.createClickHistory(product)
  }

    createClickHistory(product: MarketAirProductsModel) {
    const model = new SearchLogClickHistoryModel();

    model.searchLogId = this.model?.id || null;
    model.productId = product?.id;
    model.productName = product?.name;
    model.uuid = product?.uuid;
    model.viewType = "PRODUCTVIEW";
    model.info = "CARDVIEW";

    this.searchLogHistoryService.create(model).toPromise();
  }

  _frontTariffNotFound() {
    this.frontTariffNotFound.emit(null);
  }
  _endTariffNotFound() {
    this.endTariffNotFound.emit(null);
  }
  _frontEndTariffNotFound() {
    this.frontEndTariffNotFound.emit(null);
  }
  toggleDetails(index: number): void {
    const detailsElement = this.detailsElements.toArray()[index].nativeElement;
    const isExpanded = detailsElement.classList.contains('expanded');

    if (isExpanded) {
      detailsElement.style.maxHeight = '0';
      detailsElement.classList.remove('expanded');
    } else {
      detailsElement.style.maxHeight = detailsElement.scrollHeight + 'px';
      detailsElement.classList.add('expanded');
    }
  }

  
  getShortWeekdays(days: string[]): string {
    if (!days || days.length === 0) return "";
    const language = this.languageService.getCurrentLanguage();

  
    const allDays = ["1", "2", "3", "4", "5", "6", "7"];
    
    const weekDaysMap = {
      tr: {
        1: "Pzt",
        2: "Sal",
        3: "Çar",
        4: "Per",
        5: "Cum",
        6: "Cmt",
        7: "Paz"
      },
      en: {
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat",
        7: "Sun"
      }
    };
  
    const allDaysLabel = language === 'tr' ? "Her Gün" : "Every Day";
  
    if (days.length === 7 && allDays.every(day => days.includes(day))) {
      return allDaysLabel;
    }
  
    const sortedDays = days.map(Number).sort((a, b) => a - b);
  
    return sortedDays
      .map(day => weekDaysMap[language][day] || "")
      .filter(Boolean)
      .join(",");
  }
  

}
